import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
export const DeleteLabelModal = (props) => {
    const { onRequestClose, labelToEdit } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submit = async () => {
        setIsSubmitting(true);
        if (labelToEdit) {
            await axios.post('/api/labels/deleteLabel', {
                label_id: labelToEdit.id,
            });
        }
        setIsSubmitting(false);
        onRequestClose();
        alert('Label deleted. Please reload the page to refresh labels.');
        window.location.reload();
    };
    return (React.createElement(Dialog, { open: true },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" },
            "Delete Label",
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            labelToEdit &&
                React.createElement("div", { className: "text-center" },
                    "Are you sure you want to delete the label ",
                    labelToEdit.labelName,
                    " and all of its occurrences?"),
            React.createElement("br", null),
            React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement(Button, { style: { padding: '10px' }, variant: "outlined", disabled: isSubmitting, onClick: onRequestClose, color: "primary" }, "Cancel"),
                React.createElement(Button, { style: { padding: '10px' }, variant: "contained", disabled: isSubmitting, onClick: submit, color: "primary" }, isSubmitting ? 'Deleting...' : 'Yes, delete this label')))));
};
